import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.checkScroll();
    window.addEventListener("scroll", this.checkScroll.bind(this));
  }

  disconnect() {
    window.removeEventListener("scroll", this.checkScroll.bind(this));
  }

  checkScroll() {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const fullHeight = document.documentElement.scrollHeight;

    const threshold = 10;

    if (
      scrollTop <= threshold ||
      scrollTop + windowHeight + threshold >= fullHeight
    ) {
      setTimeout(() => {
        this.element.removeAttribute("data-small");
      }, 200);
    } else {
      this.element.dataset.small = true;
    }
  }
}
